import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import { Tooltip } from '@chilecompra/react-kit/components'
import Instance from 'highcharts'
import MoreAddOn from 'highcharts/highcharts-more'
import SolidGaugeAddOn from 'highcharts/modules/solid-gauge'
import Highcharts from 'highcharts-react-official'
import { formatAmount } from '../../modules/utils/formatters'
import {
  Circle,
  Datum,
  Detail,
  ExclamationIcon,
  GlobalStyle,
  GridContainer,
  GridItem,
  Name,
  Percentage,
  Strong
} from './DonutsChart.styles'

MoreAddOn(Instance)
SolidGaugeAddOn(Instance)

/**
 * The DonutsChart's component.
 */
const DonutsChart = props => {
  const { data, id } = props
  const theme = useTheme()
  const options = {
    accessibility: { enabled: false },
    chart: { height: '100%', type: 'solidgauge' },
    pane: {
      background: [
        {
          backgroundColor: theme.palette.brand.gray2,
          borderWidth: 0,
          innerRadius: '0%',
          outerRadius: '100%'
        },
        {
          backgroundColor: theme.palette.brand.white,
          borderWidth: 0,
          innerRadius: '0%',
          outerRadius: '62%'
        }
      ],
      endAngle: 360,
      startAngle: 0
    },
    plotOptions: {
      solidgauge: {
        dataLabels: { enabled: false, verticalAlign: 'middle' }
      }
    },
    title: { text: undefined },
    tooltip: { enabled: false },
    yAxis: {
      lineWidth: 0,
      max: 100,
      min: 0,
      tickPositions: []
    }
  }

  return (
    <>
      <GlobalStyle />
      <GridContainer id={id}>
        {data.map((datum, index) => (
          <GridItem xs key={index}>
            <GridContainer>
              <GridItem align="center" xs={12}>
                <Name>
                  <Strong>{datum.name}</Strong>&nbsp;<Percentage>({datum.percentage}%)</Percentage>
                  {datum.tooltip && (
                    <Tooltip content={datum.tooltip} placement="top">
                      <Circle>
                        <ExclamationIcon />
                      </Circle>
                    </Tooltip>
                  )}
                </Name>
              </GridItem>
            </GridContainer>
            <GridContainer justifyContent="center">
              <GridItem xs={6}>
                <Highcharts
                  highcharts={Instance}
                  options={{
                    ...options,
                    series: [{ data: [{ color: datum.color, radius: '100%', y: datum.percentage }] }]
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <Datum>{`$${formatAmount(datum.amount)}`}</Datum>
              </GridItem>
            </GridContainer>
            <GridContainer margin="6px 0 0">
              <GridItem xs={12}>
                <Detail>{datum.detail}</Detail>
              </GridItem>
            </GridContainer>
          </GridItem>
        ))}
      </GridContainer>
    </>
  )
}

DonutsChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      color: PropTypes.string,
      detail: PropTypes.string,
      name: PropTypes.string,
      percentage: PropTypes.number,
      tooltip: PropTypes.string
    })
  ).isRequired,
  id: PropTypes.string.isRequired
}

export default DonutsChart
